import { useState } from "react";
import "./checkbox.css";

export const Checkbox = () => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <div className="checkbox">
      <input
        className={isChecked ? "checked" : ""}
        type="checkbox"
        checked={isChecked}
        onChange={() => setIsChecked((prev) => !prev)}
      />
    </div>
  );
};
